/**
 * Thin WebSocket wrapper implementing the ClientMessage/ServerMessage wire
 * protocol from src/sim/types.ts. Connects to `/api/room/{ROOMCODE}/ws` on
 * the same origin (vite dev proxies /api to wrangler; production is one
 * Worker serving both).
 */

import type { ClientMessage, ServerMessage } from '../sim';

export class NetClient {
  private ws: WebSocket;

  onOpen: () => void = () => {};
  onMessage: (msg: ServerMessage) => void = () => {};
  onClose: (ev: CloseEvent) => void = () => {};
  onError: (ev: Event) => void = () => {};

  constructor(roomCode: string) {
    const proto = location.protocol === 'https:' ? 'wss' : 'ws';
    const url = `${proto}://${location.host}/api/room/${encodeURIComponent(roomCode)}/ws`;
    this.ws = new WebSocket(url);
    this.ws.addEventListener('open', () => this.onOpen());
    this.ws.addEventListener('close', (ev) => this.onClose(ev));
    this.ws.addEventListener('error', (ev) => this.onError(ev));
    this.ws.addEventListener('message', (ev) => {
      try {
        const msg = JSON.parse(String(ev.data)) as ServerMessage;
        this.onMessage(msg);
      } catch {
        // ignore malformed frames
      }
    });
  }

  send(msg: ClientMessage): void {
    if (this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(JSON.stringify(msg));
    }
  }

  close(): void {
    try {
      this.ws.close();
    } catch {
      // ignore
    }
  }
}
